import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { getValueFromLocalStorage } from '../share/defaultDoc';
import type { Notification, NotificationDocument } from './notification.types';

export const notificationPullQueryBuilder = (document: Notification) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { datecreated: '1900-01-01T01:01:01.1234567-06:00' };
  }
  const query = print(gql`
    query mobileAlertNotifications($siteId: Int!, $disciplineId: Int!, $lastRequested: DateTime!) {
      mobileAlertNotifications(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        pkUSerAlertId
        alertNotificationId
        userId
        alertText
        isRead
        isMobileAlert
        createdBy
        firstName
        lastName
        roleId
        site
        discipline
        datecreated
        isActive
        alertMetaData
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        null,
        doc?.datecreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export const notificationPushQueryBuilder = (doc: NotificationDocument[]) => {
  const query = doc[0].isActive
    ? print(gql`
        mutation mobileMarkAlertAsRead($alerts: [Int]!) {
          mobileMarkAlertAsRead(alerts: $alerts)
        }
      `)
    : print(gql`
        mutation mobileMarkAlertAsDisabled($alerts: [Int]!) {
          mobileMarkAlertAsDisabled(alerts: $alerts)
        }
      `);
  const variables = {
    alerts: [doc[0].alertNotificationId],
  };
  return {
    query,
    variables,
  };
};
